export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/elearning_content_development.61e4655.svg";